export default {
  rewardList: [],
  rewardData: {items: [], _links: {}, _meta: {}},

  rewardHistoryList: [],
  rewardHistoryData: {items: [], _links: {}, _meta: {}},
}
